import * as React from 'react';
import { IconTable16, IconMap16, InlineText2, TColors } from '@cian/ui-kit';
import { TViewMode } from '../../containers/Projects/types';
import * as styles from './ViewModeSwitch.css';

interface IViewModeSwitchProps {
  mode: TViewMode;
  onModeChange: (newMode: TViewMode) => void;
}

export function ViewModeSwitch(props: IViewModeSwitchProps) {
  const { mode, onModeChange } = props;
  const tileActiveColor: TColors | undefined = mode === 'tile' ? 'primary_100' : undefined;
  const mapActiveColor: TColors | undefined = mode === 'map' ? 'primary_100' : undefined;

  const handleViewModeChange = React.useCallback(
    (type: TViewMode) => () => {
      onModeChange(type);
    },
    [onModeChange],
  );

  return (
    <div>
      <button className={styles['switch']} type="button" onClick={handleViewModeChange('tile')}>
        <span className={styles['switch__icon']}>
          <IconTable16 color={tileActiveColor} />
        </span>
        <InlineText2 color={tileActiveColor}>Плитками</InlineText2>
      </button>
      <button className={styles['switch']} type="button" onClick={handleViewModeChange('map')}>
        <span className={styles['switch__icon']}>
          <IconMap16 color={mapActiveColor} />
        </span>
        <InlineText2 color={mapActiveColor}>На карте</InlineText2>
      </button>
    </div>
  );
}
